import React, { Component } from 'react';
import { Card, Button, Form } from 'react-bootstrap';
import ForgetPass from './forgetpass'
import {forgotPassword} from '../../resources/API';
import SimpleModal from '../../components/modal/SimpleModal';
import { createBrowserHistory } from 'history';
import LoadingModal from '../../components/modal/LoadingModal';


import "./Login.css"

export default class Login extends Component {
    constructor() {
        super();
        this.state = {
            isForgetPass: false,
            isReset: false,
            user: {
                username: "",
                password: ""
            },            
            modal :{
              header : null,
              body : null,
              footer : null,
              show : false,
              variant : 'scb'
            },
            loadingShow : false,
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const {user, isReset} = this.state;
        this.props.onAuthen(user, isReset);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        let currentState = this.state.user;
        let currentReset = this.state.isReset;
        currentState[name] = value;
        this.setState({
            user: currentState,
            isReset: currentReset
        });
    }

    onResetPassword = async (username) => {
        this.setState({loadingShow:true});
        const forgotPasswordResponse = await forgotPassword(username);
        this.setState({loadingShow:false});
        if (forgotPasswordResponse.status === 200) {
            this.setState({
                modal: {
                        header : "Notification",
                        body : "Temporary password has been sent to your email address.",
                        footer : null,
                        show : true,
                        variant : 'scb'
                    },
                isForgetPass : false
              });
        } else if(forgotPasswordResponse.status === 404) {
            this.setState({
                modal: {
                        header : "Error",
                        body : "You have entered invalid username, please try again.",
                        footer : null,
                        show : true,
                        variant : 'danger'
                    }
              });
        } else {
            this.setState({
                modal: {
                        header : "Error",
                        body : "Service is temporarily unavailable, please try again later.",
                        footer : null,
                        show : true,
                        variant : 'danger'
                    }
              });
        }
    }

    handleModalClose = async () => {    
        let modal = this.state.modal;
        modal.show = false;
        this.setState({
          modal: modal
        });
      }

    setComponent = (isForgetPass) => {
        this.setState({isForgetPass: isForgetPass})
    }

    render() {
        const history = createBrowserHistory();
        history.push('/');
        const {user, isReset, modal, loadingShow} = this.state;
        return (
            <React.Fragment>
                {
                    this.state.isForgetPass ? <ForgetPass handleChange={this.handleChange} username={user.username} onResetPassword={this.onResetPassword} onBack={this.setComponent} /> :
                        <Card className="shadow mt-5 mx-auto mb-xt card-width-300">
                            <Card.Header>
                                <h2 className="text-scb font-weight-bold">SCB Payment Gateway</h2>
                                <h6>Merchant Admin Portal</h6>
                            </Card.Header>
                            <Card.Body>
                                <p className="text-scb font-weight-bold"> Login to your account</p>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Group controlId="formUsername" className="pt-2">
                                        <Form.Label>Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter your username"
                                            name="username"
                                            value={user.username}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formPassword" className="pt-2">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Enter your password"
                                            name="password"
                                            value={user.password}
                                            onChange={this.handleChange}
                                        />
                                        <Form.Text className="text-danger">
                                            {this.props.authResponse}
                                        </Form.Text>
                                    </Form.Group>
                                    <div className="d-flex justify-content-end">
                                        <p className="text-scb forget-password" onClick={() => this.setComponent(true)}>
                                            Forgot Password?
                                        </p>
                                    </div>
                                    <Button className="mt-4 mb-3" variant="scb" type="submit" block>
                                        Sign In
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                }
                <LoadingModal show={loadingShow} />
                <SimpleModal
                    modal={modal}
                    onClose={this.handleModalClose}
                />
            </React.Fragment>
        );
    }
}
